/*
 * @Description: 公共枚举
 * @Author: WangYuhan
 * @Date: 2022-11-01 16:43:01
 * @LastEditTime: 2023-05-24 11:04:42
 * @LastEditors: WangYuhan
 */

import { get, post, prefix } from './base';

// 枚举值
export function getEnum(params) {
  return get(`${prefix}enum`, params);
}
